import { useTranslations } from 'next-intl'

/**
 * A transaction's displayed status, in the catalogue's words: course/ticket
 * statuses (`displayedPaymentStatus`) and membership ones share one scale.
 * Keys are literal so the catalogue-coverage spec can see them.
 */
export function useStatusLabel(): (status: string) => string {
  const t = useTranslations('transactions')
  const labels: Record<string, string> = {
    completed: t('status.completed'),
    active: t('status.active'),
    pending: t('status.pending'),
    incomplete: t('status.incomplete'),
    refunded: t('status.refunded'),
    past_due: t('status.past_due'),
    failed: t('status.failed'),
    abandoned: t('status.abandoned'),
    canceled: t('status.canceled'),
    cancelled: t('status.canceled'),
  }
  return status => labels[status] ?? status
}
